export default "__VITE_ASSET__BPFEyflE__"